import { combineReducers } from '@reduxjs/toolkit';

import { acceptanceAdvancedReducer } from '@entities/acceptanceAdvanced';
import { configFlagsReducer } from '@shared/lib/configFlags';
import { featureFlagsReducer } from '@shared/lib/featureFlags';
import { globalPollingReducer } from '@shared/lib/globalPolling';
import { modalStackReducer } from '@shared/lib/modal';
import { uploadsReducer } from '@shared/lib/uploads';

import { createPointsGroupReducer } from 'application/pages/PointsGroupsPage/renderer/slices/createPointsGroup/slice';
import { createAdCampaignReducer } from 'application/pages/AdsPage/slices/createAdCampaign/slice';
import { applicationReducer } from '@app/store/application';
import { accountReducer } from '@entities/account';

export const rootReducer = combineReducers({
  application: applicationReducer,
  acceptanceAdvanced: acceptanceAdvancedReducer,
  account: accountReducer,
  configFlags: configFlagsReducer,
  featureFlags: featureFlagsReducer,
  globalPolling: globalPollingReducer,
  createPointsGroup: createPointsGroupReducer,
  createAdCampaign: createAdCampaignReducer,
  uploads: uploadsReducer,
  modalStack: modalStackReducer,
});
